





















import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

// model
import { PropOptionRadio } from '@/models'

@Component({
  name: 'Radio'
})
export default class Radio extends Vue {
  @Prop({ default: false }) readonly required!: boolean
  @Prop({ default: '' }) readonly id!: string | number
  @Prop({ default: '' }) readonly name!: string
  @Prop({ default: '' }) readonly label!: string
	@Prop({ default: '' }) readonly default!: string
	@Prop({ required: true }) readonly options!: PropOptionRadio[]

	value = this.default

  input () {
    this.$emit('input', this.value)
    this.$emit('change', this.value)
  }

  @Watch('default', { immediate: true, deep: true })
  changeOptions (newValue: string, oldValue: string) {
    if (newValue !== oldValue) {
      this.value = this.default
      this.input()
    }
  }
}
